/** @jsxImportSource ../i18n */
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

export const PRIVACY_KEY = 'ui.privacy';

const PrivacyContext = createContext({ hidden: false, toggle: () => {}, setHidden: () => {} });

export const PrivacyProvider = ({ children }) => {
  const [hidden, setHiddenState] = useState(() => localStorage.getItem(PRIVACY_KEY) === '1');

  const setHidden = useCallback((value) => {
    setHiddenState(Boolean(value));
    localStorage.setItem(PRIVACY_KEY, value ? '1' : '0');
  }, []);

  const toggle = useCallback(() => {
    setHiddenState((current) => {
      localStorage.setItem(PRIVACY_KEY, current ? '0' : '1');
      return !current;
    });
  }, []);

  const value = useMemo(() => ({ hidden, toggle, setHidden }), [hidden, toggle, setHidden]);
  return <PrivacyContext.Provider value={value}>{children}</PrivacyContext.Provider>;
};

export const usePrivacy = () => useContext(PrivacyContext);
